export const EDITOR_ID = 'qlf-editor';
export const CONTAINER_ID = 'qlf-editor-container';
export const CANVAS_ID = 'qlf-editor-canvas';
export const ACTION_PANEL_ID = 'qlf-editor-action-panel';
export const DEVICES_PANEL_ID = 'qlf-editor-device-panel';
export const BLOCKS_ID = 'qlf-editor-blocks';
export const TRAITS_ID = 'qlf-editor-traits';
export const STYLES_ID = 'qlf-editor-styles';

export const DEVICE_TRANSITION_DURATION = 300;
